import type {
  RegistrantLicenseListLicenseResponseSchema,
  RegistrantLicenseListQuestionColumnSchema,
} from "@/hera-api/client/types.gen";

function isAmsColumnLabel(label: string): boolean {
  const normalized = label.trim().toUpperCase();
  return (
    normalized === "AMS" ||
    normalized.includes("[AMS]") ||
    normalized.includes("(AMS)") ||
    normalized.includes("ASSET MANAGER")
  );
}

/** Find the AMS question column, if one is configured for this account. */
export function findAmsQuestionColumn(
  columns: RegistrantLicenseListQuestionColumnSchema[] | undefined,
): RegistrantLicenseListQuestionColumnSchema | null {
  for (const col of columns ?? []) {
    if (col.tag?.toUpperCase() === "AMS") {
      return col;
    }
  }
  for (const col of columns ?? []) {
    if (isAmsColumnLabel(col.label)) {
      return col;
    }
  }
  return null;
}

export function getLicenseAmsCompanyName(
  license: RegistrantLicenseListLicenseResponseSchema,
  amsColumnKey: string | null,
): string {
  if (!amsColumnKey) return "";
  return license.question_column_values?.[amsColumnKey]?.trim() ?? "";
}

/** Distinct non-empty AMS company names from licenses. */
export function uniqueAmsCompanyNames(
  licenses: RegistrantLicenseListLicenseResponseSchema[],
  amsColumnKey: string | null,
): string[] {
  if (!amsColumnKey) return [];
  const seen = new Set<string>();
  const names: string[] = [];
  for (const license of licenses) {
    const name = getLicenseAmsCompanyName(license, amsColumnKey);
    if (!name || seen.has(name)) continue;
    seen.add(name);
    names.push(name);
  }
  return names.sort((a, b) => a.localeCompare(b));
}

export function licenseMatchesSelectedAms(
  license: RegistrantLicenseListLicenseResponseSchema,
  selectedAms: string | null,
  amsColumnKey: string | null,
): boolean {
  if (!selectedAms) return true;
  return getLicenseAmsCompanyName(license, amsColumnKey) === selectedAms;
}
